module.exports = __webpack_public_path__ + "static/media/babur.6e9cc834.jpg";